import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField,
  Typography,
} from '@mui/material';

const GOOGLE_FORM_ACTION =
  'https://docs.google.com/forms/u/0/d/e/1FAIpQLScjyRth6NJuPfX9PqB3lsUN5h6nnst64OxpQJ4dzk0JuiDRsA/formResponse';

const ISSUE_LOCATIONS = [
  'home page',
  'adding task',
  'task view',
  'time trial',
  'rewards page',
  'schedules',
];

const ISSUE_FREQUENCIES = [
  'Every time (100% of the time)',
  'Most of the time (75% of the time)',
  'Sometimes (50% of the time)',
  'Rarely (Less than 25% of the time)',
];

export default function Feedback() {
  const [details, setDetails] = useState('');
  const [issueLocation, setIssueLocation] = useState('');
  const [issueFrequency, setIssueFrequency] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    setSubmitted(true);
    setTimeout(() => {
      setDetails('');
      setIssueLocation('');
      setIssueFrequency('');
    }, 300);
  };

  return (
    <Container id="feedback-page" maxWidth="md" sx={{ py: { xs: 3, md: 5 } }}>
      <Box id="feedback-introduction" sx={{ display: 'grid', gap: 2, mb: 3 }}>
        <Typography variant="h3" component="h1">
          Dopatize Feedback
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Used to make Dopatize better for all users. Fill it out to the best of your ability.
        </Typography>
      </Box>

      <Paper
        id="feedback-panel"
        elevation={0}
        sx={{
          p: { xs: 2, md: 3 },
          borderRadius: 3,
          border: '2px solid',
          borderColor: 'secondary.main',
          background:
            'linear-gradient(135deg, rgba(0,229,255,0.12) 0%, rgba(10,15,13,0.96) 42%)',
          backdropFilter: 'blur(8px)',
        }}
      >
        {submitted && (
          <Alert
            severity="success"
            sx={{ mb: 2, border: '2px solid', borderColor: 'green.main', color: 'green.main' }}
          >
            Thanks! Your feedback was sent.
          </Alert>
        )}

        <Box
          id="feedback-form"
          component="form"
          action={GOOGLE_FORM_ACTION}
          method="POST"
          target="feedback-submit-target"
          onSubmit={handleSubmit}
          sx={{ display: 'grid', gap: 3 }}
        >
          <TextField
            id="feedback-details"
            name="entry.1762038163"
            label="Describe your feedback in as much detail as possible"
            value={details}
            onChange={(e) => setDetails(e.target.value)}
            multiline
            minRows={5}
            required
            fullWidth
          />

          <Divider
            sx={{
              borderColor: 'transparent',
              height: 2,
              background:
                'linear-gradient(90deg, rgba(255,45,149,0) 0%, rgba(255,45,149,0.85) 50%, rgba(255,45,149,0) 100%)',
            }}
          />

          <FormControl id="feedback-location">
            <FormLabel sx={{ color: 'secondary.main', mb: 1 }}>
              Where does the issue happen (if applicable)
            </FormLabel>
            <RadioGroup
              id="feedback-location-options"
              name="entry.1143220781"
              value={issueLocation}
              onChange={(e) => setIssueLocation(e.target.value)}
            >
              {ISSUE_LOCATIONS.map((option) => (
                <FormControlLabel
                  key={option}
                  value={option}
                  control={<Radio />}
                  label={option}
                />
              ))}
            </RadioGroup>
          </FormControl>

          <Divider
            sx={{
              borderColor: 'transparent',
              height: 2,
              background:
                'linear-gradient(90deg, rgba(0,229,255,0) 0%, rgba(0,229,255,0.85) 50%, rgba(0,229,255,0) 100%)',
            }}
          />

          <FormControl id="feedback-frequency">
            <FormLabel sx={{ color: 'secondary.main', mb: 1 }}>
              If this feedback is about a bug, how frequently does this issue occur?
            </FormLabel>
            <RadioGroup
              id="feedback-frequency-options"
              name="entry.82044135"
              value={issueFrequency}
              onChange={(e) => setIssueFrequency(e.target.value)}
            >
              {ISSUE_FREQUENCIES.map((option) => (
                <FormControlLabel
                  key={option}
                  value={option}
                  control={<Radio />}
                  label={option}
                />
              ))}
            </RadioGroup>
          </FormControl>

          <Divider
            sx={{
              borderColor: 'transparent',
              height: 2,
              background:
                'linear-gradient(90deg, rgba(57,255,20,0) 0%, rgba(57,255,20,0.85) 50%, rgba(57,255,20,0) 100%)',
            }}
          />

          <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
            <Button id="feedback-submit" type="submit" variant="contained">
              Submit Feedback
            </Button>
          </Box>
        </Box>

        <Box
          component="iframe"
          title="feedback-submit-target"
          name="feedback-submit-target"
          sx={{ display: 'none' }}
        />
      </Paper>
    </Container>
  );
}
